import { render, staticRenderFns } from "./PageActionsDictionary.vue?vue&type=template&id=0713c214&"
import script from "./PageActionsDictionary.vue?vue&type=script&lang=js&"
export * from "./PageActionsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0713c214')) {
      api.createRecord('0713c214', component.options)
    } else {
      api.reload('0713c214', component.options)
    }
    module.hot.accept("./PageActionsDictionary.vue?vue&type=template&id=0713c214&", function () {
      api.rerender('0713c214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/actionsDictionary/PageActionsDictionary.vue"
export default component.exports